import PropTypes from 'prop-types';
import React from 'react';
import { HoverCard } from '@99designs/common/components/HoverCard';
import uniqueId from 'lodash.uniqueid';

// Confirmation popup is a variation of the HoverableElement/Tooltip
// Using the styles and positioning but without the hover interaction
const ConfirmationPopup = ({ children, content, variations, isActive }) => {
    const id = uniqueId('confirmation_');
    return (
        <span className="hover-card-anchor" id={id}>
            {children}
            <HoverCard
                anchorNodeSelector={'#' + id}
                hasAnimation={true}
                hasTransition={false}
                hoverPosition="up-center"
                isActive={isActive}
                type="tooltip"
                variations={variations}
            >
                <span data-tooltip-trigger-element>
                    <span className="hover-card__content__inner" role="tooltip" aria-hidden={false}>
                        {content}
                    </span>
                </span>
            </HoverCard>
        </span>
    );
};

ConfirmationPopup.propTypes = {
    children: PropTypes.element.isRequired,
    content: PropTypes.element.isRequired,
    isActive: PropTypes.bool.isRequired,
    variations: PropTypes.array,
};

export default ConfirmationPopup;



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/entries/components/confirmation-popup.jsx